export const HUB_REGISTRATION_FORM_CONFIGURATION_URL =
    'account/{accountId}/event-hub/{eventHubId}/registration-configuration/form';

export const HUB_CUSTOM_FIELD_DELETE_URL =
    'account/{accountId}/event-hub/{eventHubId}/registration-configuration/form/custom-field/{customFieldId}';
